import BaseError from './BaseError'

// 別タブでログインして、fetchMe などの初期化処理が行われていない場合のエラー
export default class UninitializedError extends BaseError {}
